import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import React from 'react';
import { FormFeedback } from 'reactstrap';
import { ErrorMessage } from 'formik';
export default (function (props) {
  return React.createElement(ErrorMessage, Object.assign({
    component: FormFeedback
  }, props));
});